const PREFIX_DIR: Record<string, string> = {
  pet: 'pets', cos: 'cos', kpr: 'keeper', item: 'items', ui: 'ui',
  land: 'lands', map: 'lands', npc: 'npc', enemy: 'enemies', fx: 'fx', bd: 'backdrop',
};

// Longest prefix first so a future multi-segment prefix sharing a stem with a single-segment
// one (e.g. a hypothetical `cos_x` distinct from `cos`) would be tried first — a plain
// split-on-first-underscore can't tell them apart. No entry needs this today.
const PREFIXES_BY_LENGTH = Object.keys(PREFIX_DIR).sort((a, b) => b.length - a.length);

/** Art bible §4: the client resolves asset paths by convention from IDs. */
export function assetUrl(id: string): string {
  const prefix = PREFIXES_BY_LENGTH.find((p) => id === p || id.startsWith(`${p}_`));
  const dir = prefix ? PREFIX_DIR[prefix] : undefined;
  if (!dir) throw new Error(`unknown asset prefix in id '${id}'`);
  return `/assets/${dir}/${id}.png`;
}
